export default __webpack_public_path__ + "static/media/homeright.62dac3c5.png";